// This file was auto-generated by Fern from our API Definition.
export var GatewayConnectionChoiceRequest;
(function (GatewayConnectionChoiceRequest) {
    GatewayConnectionChoiceRequest.Provider = {
        Composio: "composio",
    };
})(GatewayConnectionChoiceRequest || (GatewayConnectionChoiceRequest = {}));
